import "../App.css";
import { Link } from "react-scroll";
function Navbar() {
  return (
    <>
      <nav>
        <div className="navitems">
          <ul>
            <li>
              <Link activeClass="active" to="home">
                ABOUT
              </Link>
            </li>
            <li>
              <Link activeClass="active" to="container">
                MENU
              </Link>
            </li>
            <li>
              <Link to="footer" activeClass="active">
                CONTACT
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
